define('views/modules/calendar/favorite/lists/favorite-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    'services/i18n',
    // collections
    'collections/calendar/favorites',
    // models
    'models/calendar/favorite',
    // views
    'views/parts/list/fetch-list',
    'views/parts/fetch-button',
    'views/modules/calendar/favorite/lists/favorite-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr,
    // src
    i18n,
    // collections
    CFavorites,
    // models
    MFavorite,
    // views
    VFetchList,
    VFetchButton,
    VFavoriteListItem
) {

    var VFavoriteList = VFetchList.extend({

        item: function(opt) {
            return new VFavoriteListItem(_.extend(opt, {
                selected: this.selected
            }));
        },

        initialize: function(opt) {

            this.collection = new CFavorites(null, {
                type: opt.type,
            });

            VFavoriteList.__super__.initialize.call(this, _.extend({
                title: "Favorites",
                icon: false,
                bottom: true,
            }, opt));

            this.selected = new MFavorite();

            // listeners
            this.listenTo(this.collection, {
                'favorite:select': this.onSelect,
                'favorite:apply': this.onApplyFavorite,
                'favorite:edit': this.onEditFavorite,
            });

        },

        render: function() {
            this.collection.reset(null, { silent: true });

            VFavoriteList.__super__.render.call(this);

            this.collection.getFirstPage();

            return this;
        },

        getSelected: function() {
            return this.selected;
        },

        getCollection: function() {
            return this.collection;
        },

        updateFavorite: function(model) {
            this.collection.set(model, { remove: false });
        },

        ////////////
        // events //
        ////////////
        onSelect: function(view, model) {
            //START: Temporary patch (Bug Cardio Exercices)
            if (model.get('type') === 'animated-session') {
                var sessionContainCardioExercice = false;
                for (var i = 0; i < model.get("data").exercises.length; i++) {
                    if (model.get("data").exercises[0].type === "cardio") {
                      sessionContainCardioExercice = true;
                      break;
                    }
                }
                if (sessionContainCardioExercice) {
                    Toastr.warning(
                        i18n.t("Cardio favorite can't be added for this moment"),
                        "", { // These options should be set globally.
                            positionClass: "toast-top-center", // Default = toast-top-right
                            newestOnTop: false, // Default = true
                            showMethod: "slideDown",    // Default = fadeIn
                            tapToDismiss: true,  // Default = false
                            timeOut: 5000,
                            hideMethod: "fadeOut",
                            hideDuration: 750,
                            closeButton: true
                        });
                    view.setActive(false);
                    return;
                }
                //END: Temporary patch (Bug Cardio Exercices)
            }

            this.children().removeClass("active");
            var isActive = this.selected.is(model);
            this.selected.reset(isActive ? undefined : model.attributes);
            view.setActive(!isActive);
            this.trigger("favorite:select", view, this.selected);
        },

        onApplyFavorite: function(model) {
            this.trigger('favorite:apply', model);
        },

        onDisable: function() {
            this.selected.reset();
        },

        onEditFavorite: function(model, view) {
            this.trigger('favorite:edit', model, view);
        }

    });

    return VFavoriteList;

});

